export default {
    PARSE: true,
    BUILD: null,
    ERROR_CODE: 'FRM',
    ERROR_LOG_ID: 397,
    /**
     * Name of usable cookies
     */
    COOKIES: {
        /**
         * JWT Cookie Name
         */
        JWT: 'JWT_USER',
        /**
         * User Cookie Name
         */
        USER: 'USER_ID',
    },
    APPLICATION_PATH: {
        LOGIN: '/',
        REGISTER: '/register',
        AUTH: '/auth',
        HOME: '/home',
        PROFILE: '/profile',
        PREFERENCES: '/profile/preferences',
        AUCTION: '/auctions',
        DIRECT_PURCHASE: '/purchase',
        RECEIVINGDEALER: '/dealer-receptor',
        LEGAL_NOTE: '/legalNote',
        PRIVACY_POLICY: '/privacyPolicy',
        COOKIES_POLICY: '/cookiesPolicy',
        LICENCE: '/licenses',
        FAQS: '/faqs',
        CONTACT: '/contact',
        HUERTO: '/huerto',
        METRICASHUERTO: '/metricasHuerto',
        TEXTOLANDINGHUERTO: '/textoLanding',
        BATCHES: '/batches',
        CLOSED_BATCH: '/closed-batch',
        ADJUDICATIONS: '/adjudications',
        SOLDVWR: '/soldvwr',
        CREATE_TICKET: '/create-ticket',
        SEARCH_TICKET: '/search-ticket',
        RENTING_RED_RAC: '/renting-red-rac',
        SEARCH_VEHICLE_STATUS: '/search-vehicle',
    },
    RENTING_VO: {
        BASE_URL: process.env.REACT_APP_FSONEVIEW_URL,
        SIMULATOR: {
            BASE_PATH: '/fsoneviewservice',
            SIMULATOR_ACCESS: '/simulatoraccess',
        },
        SEARCH: {
            BASE_PATH: '/fsoneviewservice',
            ACCESS: '/searchaccess',
        },
    },

    BFF_PATH: {
        BASE_URL: process.env.REACT_APP_BFF_URL,
        CONTRACT: {
            BASE_PATH: '/ContractsService',
            GET_MATRIX_RENTING: '/read-scoring-renting-matrix-by-dealer',
            GET_RENTING_EXPIRATION: '/read-renting-expiration-by-filter',
            GET_RENTING_EXPIRATION_EXCEL:
                '/read-renting-expiration-by-filter-to-excel',
            GET_RENTING_EXPIRATION_ASIGNADOS:
                '/read-renting-expiration-by-filter-asignados',
            GET_RENTING_EXPIRATION_ASIGNADOS_EXCEL:
                '/read-renting-expiration-by-filter-asignados-to-excel',
            GET_RENTING_INFORMATION_VEHICLE:
                '/read-renting-information-vehicle',
            GET_RENTING_INFORMATION_CONTRACT:
                '/read-renting-information-contract',
            GET_RENTING_INFORMATION_CLIENT: '/read-renting-information-client',
            GET_RENTING_CLIENT_LIST: '/read-renting-client-list',
        },
        FILTER: {
            BASE_PATH: '/FilterService',
            GET_BRAND_LIST: '/get-brand-list',
        },
        LOG: {
            BASE_PATH: '/LoggingService',
            CREATE: '/post-log',
        },
        USER: {
            BASE_PATH: '/UserService',
            GET_USER: '/get-user',
            GET_USER_REGISTER: '/get-user-register-form',
            REGISTER: '/post-register',
        },
        LOGIN: {
            BASE_PATH: '/LoginService',
            DO: '/login',
            REFRESH: '/refresh-context',
            REFRESH_TOKEN: '/refresh-token',
            SERVER_TIME: '/server-time',
            RESET_PASSWORD: '/reset-password',
        },
        SELL: {
            BASE_PATH: '/SellService',
            BUY_VEHICLE: '/post-buy-vehicle',
            BUY_VEHICLE_RECEPTOR: '/post-buy-vehicle-receptor',
            GET_BUYERS: '/get-buyers',
            REJECT_VEHICLE: '/post-decision-no-buy-vehicle',
            NEGOTIATE_VEHICLE: '/post-decision-counteroffer-vehicle',
            OFFER_VEHICLE: '/insert-offer-amount',
            GET_BILL: '/get-bill',
            GET_BILL_VWR: '/get-bill-vwr',
            GET_DOCUMENTS_FOR_SALE: '/get-documents-for-sale',
            GET_DOCUMENT_FOR_SALE_BY_ID: '/get-document-for-sale-by-id',
            UPDATE_PICKUP_DATE: '/post-update-pickup-date',
            SEND_DELIVERY_CERTIFICATE: '/post-send-delivery-certificate',
        },
        TRANSPORT: {
            BASE_PATH: '/TransportService',
            GET: '/get-transport-request',
            UPDATE: '/update-data-tranport-solicitude',
            GET_PRICE: '/get-transport-price',
            GET_PROVINCE_CODE: '/get-code-province-by-code-zip',
            GET_DEALER_DATA: '/get-consesionarie-data',
            GET_POBLATION: '/get-poblation-by-code-zip',
            GET_STREET_TYPE: '/get-type-way',
            GET_BRAND_STATISTICS: '/get-branch-estadistics',
            GET_PROFORMA: '/get-proforma',
        },
        VEHICLE: {
            BASE_PATH: '/VehicleService',
            GET: '/get-vehicles',
            GET_VEHICLES_ADJUDICATION: '/get-vehicles-adjudication',
            GET_VEHICLES_SoldVWR: '/get-vehicles-soldvwr',
            GET_ADJUDICATION_COUNT: '/get-number-adjudication',
            GET_RECEPTOR_DEALERS: '/get-vehicles-receptor-dealer',
            GET_RECEPTOR_DEALERS_COUNT: '/get-number-vehicles-receptor',
            AUCTIONS: '/get-agrupations',
            FILTERS: '/get-filters',
            FILTERS_ADJUDICATION: '/get-filters-adjudication',
            FILTERS_ADJUDICATION_MONTH:
                '/get-month-filter-vehicles-adjudication',
            FILTERS_RECEIVING_DEALERS: '/get-filters-receptor-dealer ',
            GET_FAVOURITE: '/get-favorites-count',
            POST_FAVOURITE: '/post-favourite-vehicle',
            REMOVE_FAVOURITE: '/remove-favourite-vehicle',
            GET_MODELS: '/get-models',
            GET_STATES_ADJUDICATION: '/get-states-vehicles-adjudication',
            DETAIL: '/get-vehicle-detail',
            GET_EXPERTISE_LIST: '/get-expertises-list',
            GET_EXPERTISE_DATA: '/get-expertise-data',
            GET_MAINTENANCE_LIST: '/get-maintenance-list',
            GET_MAINTENTANCE_DETAILS_LIST: '/get-maintenance-details-list',
            GET_NOT_BUY_TYPE: '/get-not-buy-type',
            GET_EXCEL_ADJUDICATED: '/get-vehicles-adjudication-to-excel',
            GET_VEHICLE_ACCIDENTS: '/get-car-accidents-record',
            GET_STATUS: '/get-vehicle-status',
            GET_CURRENT_EXPORTER_OFFER: '/get-exporter-vehicle-offer',
            GET_INFORMATION: '/get-vehicle-information',
        },
        DEALER: {
            BASE_PATH: '/UserService',
            GET_DEALER_CODE: '/get-dealer-code',
            GET_DEFAULT_DEALER: '/get-default-dealer',
        },
        GLOBAL_VARIABLES: {
            BASE_PATH: '/UserService',
            GET_GLOBAL_VARIABLE: '/get-global-variable',
        },
        BATCHES: {
            BASE_PATH: '/BachService',
            //Open Batches Paths
            CREATE_BATCH: '/create-bach',
            DELETE_BATCH: '/delete-batch',
            DELETE_BATCH_VEHICLE: '/delete-vehicle-bach',
            GET_BATCHES: '/get-bachs',
            EDIT_BATCH_VEHICLES: '/update-amountoffered-vehicle-bach',
            ADD_VEHICLES_TO_BATCH: '/add-vehicle-to-bach',
            EDIT_BATCH_NAME: '/update-batch-name',
            GET_BATCH_DETAILS: '/get-bach-vehicles',
            //Closed Batches Paths
            GET_CLOSED_BATCHES: '',
            GET_CLOSED_BATCH_DETAILS: '/get-vehicles-closed-batch',
            BUY_CLOSED_BATCH: '/adjudicate-closed-bach',
            BID_CLOSED_BATCH: '',
            UPDATE_CLOSED_BATCHES_AMOUNTS: '',
        },
        TICKETING: {
            BASE_PATH: '/TicketingService',
            CREATE_TICKET: '/post-ticket',
            GET_TICKETS: '/get-tickets',
            GET_ALL_SELECTS: '/get-filters-ticket',
            GET_INFO_TICKET: '/get-info-ticket',
        },
        RENTING: {
            BASE_PATH: '/RentingService',
            GET_FILTERS: '/get-filters',
            GET_VEHICLES: '/read-vehicles-renting-red-rac',
            GET_VEHICLE_PRICES: '/read-vehicles-renting-red-rac-prices',
            GET_CUSTOMER: '/read-customer',
            GET_POBLATION: '/get-poblation-by-code-zip-customer',
            BUY_VEHICLE: '/buy-vehicle',
        },
    },
};
